export const wrapInHtmlNode = <T extends keyof HTMLElementTagNameMap = "div">(
  wrapperType: T,
  children: Array<HTMLElement> = [],
  className = "",
) => {
  const w = document.createElement(wrapperType);

  if (className) {
    w.className = className;
  }

  children.forEach((c) => {
    w.appendChild(c);
  });

  return w;
};
